export const environment = {
  production: true,
  frenchPublicHolidayAPIUri:
    'https://calendrier.api.gouv.fr/jours-feries/metropole/',
  directusApiUrl: 'https://services.voiney.fr/directus',
};
